export default function PageHero({ eyebrow, title, subtitle, image, children }) {
    return (
        <section className="relative overflow-hidden bg-[#061A2E]">
            {image && (
                <div className="absolute inset-0">
                    <img src={image} alt="" className="w-full h-full object-cover opacity-30" loading="eager" />
                    <div className="absolute inset-0 bg-gradient-to-b from-[#061A2E]/70 via-[#0A2540]/85 to-[#0A2540]" />
                </div>
            )}
            <div className="relative container-x pt-36 pb-24 sm:pt-40 sm:pb-28">
                <div className="max-w-4xl">
                    {eyebrow && <div className="overline text-[#F59E0B] mb-6">{eyebrow}</div>}
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.05]">
                        {title}
                    </h1>
                    {subtitle && (
                        <p className="mt-6 text-lg sm:text-xl text-white/75 leading-relaxed max-w-3xl">{subtitle}</p>
                    )}
                    {children && <div className="mt-8">{children}</div>}
                </div>
            </div>
        </section>
    );
}
